import React, { useEffect, useState } from 'react'
import moment from 'moment'
import styles from './Blog.module.css'
import Hero from '../Hero/Hero'
import ApolloImage from '../../assets/images/png/apollo-blog.png'
import rightArrow from '../../assets/images/svg/right-arrow.svg'
import grayRightArrow from '../../assets/images/svg/right-arrow-gray.svg'
import LoaderPage from '../Loader/LoaderPage/LoaderPage'
import texts from './texts'
import truncate from '../../utils/truncate'

const heroSmall = require('../../assets/images/png/mx-blog-small.png')

const heroSrc = {
  small: heroSmall,
  default: heroSmall
}
const { REACT_APP_BASE_URL_BLOG_API } = process.env
const options = {
  method: 'get', headers: new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' })
}
const defaults = {
  perPage: 10,
  step: 1,
  top: 400,
  initial: 0,
  ellipsisTitle: 25,
  ellipsisSummary: 50,
  ellipsisBigSummary: 155
}


const Blog = () => {
  const [beforeActive, setBeforeActive] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [afterActive, setAfterActive] = useState(true)
  const [skip, setSkip] = useState(defaults.initial)
  const [page, setPage] = useState(defaults.step)
  const [pages, setPages] = useState([])
  const [entries, setEntries] = useState([])
  const [popularEntries, setPopularEntries] = useState([])

  const handleNextPage = () => {
    setIsLoading(true)
    const newSkip = skip + defaults.perPage
    const newPage = page + defaults.step
    setPage(newPage)
    setBeforeActive(true)
    setSkip(newSkip)
    fetch(`${REACT_APP_BASE_URL_BLOG_API}list?limit=10&skip=${newSkip}&country=mx&sort=createdAt`,
    options).then(response => response.json().then(data => ({
      data,
      status: response.status
    })).then(res => {
      setEntries(res.data.entries)
      window.scroll(defaults.initial, defaults.top)
      pages[page - defaults.step].active = false
      pages[page].active = true
      if (res.data.entries.length < defaults.perPage) {
        setAfterActive(false)
      }
      setIsLoading(false)
    }))
  }

  const handleBeforePage = () => {
    setIsLoading(true)
    const newSkip = skip - defaults.perPage
    const newPage = page - defaults.step
    setSkip(newSkip)
    fetch(`${REACT_APP_BASE_URL_BLOG_API}list?limit=10&skip=${newSkip}&country=mx&sort=createdAt`,
    options).then(response => response.json().then(data => ({
      data,
      status: response.status
    })).then(res => {
      setEntries(res.data.entries)
      window.scroll(defaults.initial, defaults.top)
      pages[newPage].active = false
      pages[newPage - defaults.step].active = true
      setPage(newPage)
      if (newPage === 1) {
        setBeforeActive(false)
      }
      if (newPage - 1 < pages.length) {
        setAfterActive(true)
      }
      setIsLoading(false)
    }))
  }

  const handlePageSelected = (pageSelected) => {
    setIsLoading(true)
    const newSkip = pageSelected * defaults.perPage
    setSkip(newSkip)
    fetch(`${REACT_APP_BASE_URL_BLOG_API}list?limit=10&skip=${newSkip}&country=mx&sort=createdAt`,
    options).then(response => response.json().then(data => ({
      data,
      status: response.status
    })).then(res => {
      setEntries(res.data.entries)
      window.scroll(defaults.initial, defaults.top)
      pages[pageSelected].active = true
      pages[page - 1].active = false
      setPage(pageSelected + defaults.step)
      if (pages.length === pageSelected + defaults.step) {
        setAfterActive(false)
        setBeforeActive(true)
      } else if (pageSelected === 0) {
        setAfterActive(true)
        setBeforeActive(false)
      } else {
        setAfterActive(true)
        setBeforeActive(true)
      }
      setIsLoading(false)
    }))
  }

  useEffect(() => {
    fetch(`${REACT_APP_BASE_URL_BLOG_API}list?limit=10&country=mx&sort=createdAt`,
    options).then(response => response.json().then(data => ({
      data,
      status: response.status
    })).then(res => {
      setEntries(res.data.entries)
      const newPages = Math.ceil(res.data.count / defaults.perPage)
      const arrayNumbers = []
      for (let i = defaults.initial; i < newPages; i++) {
        if (i === defaults.initial) {
          arrayNumbers.push({ number: i, active: true })
        } else {
          arrayNumbers.push({ number: i, active: false })
        }
      }
      setPages(arrayNumbers)
    }))

    fetch(`${REACT_APP_BASE_URL_BLOG_API}list?limit=5&country=mx&sort=views`,
    options).then(response => response.json().then(data => ({
      data,
      status: response.status
    })).then(res => {
      setPopularEntries(res.data.entries)
    }))
  }, [])

  const goToPost = (slug) => {
    window.location = `/blog/${slug}`
  }

  return (
    <div>
      <Hero srcset={heroSrc}>
        <div
          className={styles.CompleteDesc}
          id="pixelHome"
        >
          <h1 className={styles.HeroTitle}>
            Te mantenemos informado
          </h1>
          <h1 className={styles.HeroDesc}>
            Consulta las últimas noticias sobre moons
          </h1>
        </div>
      </Hero>
      <img
        src={ApolloImage}
        alt="apollo"
        className={styles.apollo}
      />
      {(entries.length === defaults.initial || popularEntries.length === defaults.initial || isLoading) && <LoaderPage />}
      <div className={styles.mainContent}>
        <div className={styles.containerEntries}>
          {entries && entries.map(item => (
            <div
              onClick={() => goToPost(item.slug)}
              className={styles.entryItem}
              key={item.objectId}
            >
              <img
                alt="cover entry"
                className={styles.EntryImage}
                src={item.coverImage}
              />
              <div className={styles.containerTextsEntry}>
                <div className={styles.containerTitles}>
                  <p className={styles.title}>{truncate(item.title, defaults.ellipsisTitle)}</p>
                  <p className={styles.category}>{item.category.name}</p>
                </div>
                <div
                  className={styles.summary}
                >
                  {truncate(item.summary, defaults.ellipsisSummary)}
                </div>
                <div
                  className={styles.summaryDesktop}
                >
                  {truncate(item.summary, defaults.ellipsisBigSummary)}
                </div>
                <p
                  className={styles.author}
                >
                  {item.author}
                  {' '}
                  {' · '}
                  {' '}
                  {moment(item.createdAt).format('DD-MM-YYYY')}
                </p>
              </div>
            </div>
          ))
          }
          {pages.length > 1 && (
            <div className={styles.pagination}>
              {beforeActive ? (
                <div
                  onClick={() => handleBeforePage()}
                  className={styles.arrowContainerActive}
                >
                  <img
                    className={styles.leftArrow}
                    src={rightArrow}
                    alt="right arrow"
                  />
                  {' '}
                  <span
                    className={styles.textPagination}
                  >
                    {texts.before}
                  </span>
                </div>
              ) : (
                <div className={styles.arrowContainer}>
                  <img
                    className={styles.leftArrow}
                    src={grayRightArrow}
                    alt="right arrow"
                  />
                  {' '}
                  <span
                    className={styles.textPagination}
                  >
                    {texts.before}
                  </span>
                </div>
              )}
              <div className={styles.numbersContainer}>
                {pages && pages.map(item => (item.active ? (
                  <div
                    key={item.number}
                    className={styles.selectedNumberWrapper}
                  >
                    <p
                      className={styles.selectedNumber}
                    >
                      {item.number + defaults.step}
                    </p>
                  </div>
                ) : (
                  <p
                    onClick={() => handlePageSelected(item.number)}
                    key={item.number}
                    className={styles.number}
                  >
                    {item.number + defaults.step}
                  </p>
                )))}
              </div>
              {afterActive ? (
                <div
                  onClick={() => handleNextPage()}
                  className={styles.arrowContainerActive}
                >
                  <span className={styles.textPagination}>{texts.after}</span>
                  {' '}
                  <img
                    className={styles.arrow}
                    src={rightArrow}
                    alt="right arrow"
                  />
                </div>
              ) : (
                <div className={styles.arrowContainer}>
                  <span className={styles.textPagination}>{texts.after}</span>
                  {' '}
                  <img
                    className={styles.arrow}
                    src={grayRightArrow}
                    alt="right arrow"
                  />
                </div>
              )}
            </div>
          )}
        </div>
        <div>
          <div className={styles.mostPopular}>
            <p className={styles.titleMostPopular}>Los más populares</p>
            <div className={styles.entriesMostPopular}>
              {popularEntries && popularEntries.map((item, index) => (
                <div
                  onClick={() => goToPost(item.slug)}
                  key={index}
                  className={styles.entryPopularContainer}
                >
                  <div>
                    <p className={styles.count}>
                      {'0'}
                      {index + defaults.step}
                    </p>
                  </div>
                  <div className={styles.textEntry}>
                    <div>
                      <p
                        className={styles.titlePopular}
                      >
                        {truncate(item.title, defaults.ellipsisTitle)}
                      </p>
                      <p className={styles.category}>{item.category.name}</p>
                    </div>
                    <p className={styles.author}>
                      {item.author}
                      {' '}
                      {' · '}
                      {moment(item.createdAt).format('DD-MM-YYYY')}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Blog
